/* eslint-disable react/require-default-props */
import React from 'react'
import * as S from './styles'
import { IGatsbyImageData } from 'gatsby-plugin-image'

interface ImageKitProps {
  readonly image?: IGatsbyImageData
  readonly imageUrl?: string
  readonly alt: string
  readonly className?: string
}

const ImageKit: React.FC<ImageKitProps> = ( { image = null, imageUrl = null, alt, className = '' } ) => {
  if ( image ) {
    return (
      <S.ImageKit
        image={ image }
        className={ className }
        alt={ alt }
      />
    )
  }

  return (
    <div>
      <img
        src={ imageUrl! }
        className={ className }
        alt={ alt }
      />
    </div>
  )
}

export default ImageKit
